import React from "react";
import { useLang } from "../../i18n/LanguageContext";
import { ArrowUpRight } from "lucide-react";

const Themes = () => {
  const { t } = useLang();
  const items = t("themes.items");
  return (
    <section id="themen" className="relative py-32 lg:py-48 bg-[#050B1B]" data-testid="themes-section">
      <div className="container-sat">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <div className="overline mb-6">{t("themes.overline")}</div>
            <h2 className="headline-xl text-4xl md:text-5xl lg:text-7xl">{t("themes.title")}</h2>
          </div>
          <p className="serif italic text-xl text-white/55 md:max-w-sm">{t("themes.subtitle")}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 rounded-2xl overflow-hidden border border-white/5" data-testid="themes-grid">
          {items.map((it, i) => (
            <div
              key={i}
              className="group relative p-10 bg-[#050B1B] hover:bg-[#0E1A30] transition cursor-pointer min-h-[220px] flex flex-col justify-between"
              data-testid={`theme-card-${i}`}
            >
              <div>
                <div className="flex items-baseline justify-between">
                  <span className="num-mark">0{i + 1}</span>
                  <ArrowUpRight size={18} className="text-white/30 group-hover:text-[#D4AF37] transition" />
                </div>
                <h3 className="serif text-3xl mt-6 font-light">{it.t}</h3>
              </div>
              <p className="text-white/55 text-sm mt-6 leading-relaxed">{it.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Themes;
